export const oldMenuKeyMap = [
    'production',
    'pool',
    'poolMangement',
    'translateRuleConfig',
    'translate',
    'translateManage',
    'ecommerceMaterialManagement',
];
